<template>
  <div class="layout">
    <div class="general">
      <div>
        <slot name="image" />
      </div>
      <div>
        <slot name="provider" />
        <div class="mobile-capacity">
          <slot name="capacity" />
        </div>
        <div class="desktop-capacity">
          <slot name="desktopCapacity" />
        </div>
      </div>
    </div>

    <div class="services">
      <slot name="services" />
    </div>

    <div class="third-block">
      <div class="cost">
        <slot name="cost" />
      </div>

      <div class="meta">
        <slot name="meta" />
      </div>

      <div class="button-order">
        <slot name="buttonOrder" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardLayout',
};
</script>

<style lang="scss" scoped>
  .layout {
    @media screen and (min-width: $tablet-width) {
      display: flex;
      justify-content: space-between;
    }
  }

  .general {
    display: flex;
    margin-bottom: 30px;
    @media screen and (min-width: $tablet-width) {
      margin-bottom: 0;

      .mobile-capacity {
        display: none;
      }
    }

    > div:first-child {
      margin-right: 30px;
      @media screen and (min-width: $tablet-width) {
        margin-right: 40px;
      }
    }

    > div:last-child {
      text-align: left;

      > div:not(:last-child) {
        margin-bottom: 16px;
      }
    }

    .desktop-capacity {
      display: none;
      @media screen and (min-width: $tablet-width) {
        display: block;
      }
    }
  }

  .services {
    text-align: left;
    @media screen and (min-width: $tablet-width) {
      display: none;
    }
  }

  .third-block {
    text-align: center;
    flex-shrink: 0;
    position: relative;
    @media screen and (min-width: $tablet-width) {
      text-align: right;
    }

    .cost {
      font-size: 38px;
      margin-top: 16px;
      margin-bottom: 20px;
      line-height: 1;
      font-weight: 600;
      @media screen and (min-width: $tablet-width) {
        margin-top: 0;
      }
      @media screen and (min-width: $desktop-width) {
        font-size: 39px;
      }
    }

    .meta {
      margin-bottom: 30px;
    }
  }
</style>
